'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var GoogleMapsContext = require('./GoogleMapsContext.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var DEFAULT_GOOGLE_MAPS_SCRIPT_ID = 'google-maps-script';
function GoogleMapsProvider(_ref) {
  var {
    scriptId = DEFAULT_GOOGLE_MAPS_SCRIPT_ID,
    apiKey,
    children
  } = _ref;
  var [state, setState] = React__namespace.useState({
    status: 'idle',
    error: null,
    google: null
  });

  function onLoad() {
    setState({
      status: 'ready',
      google: window.google,
      error: null
    });
  }

  function onError() {
    setState({
      status: 'error',
      google: window.google,
      error: null
    });
  }

  React__namespace.useEffect(() => {
    var existingScript = document.getElementById(scriptId);

    if (existingScript || window.google) {
      return onLoad();
    }

    setState(_rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, state), {}, {
      status: 'loading'
    }));
    var script = document.createElement('script');
    script.setAttribute('async', '');
    script.setAttribute('id', scriptId);
    var src = "https://maps.googleapis.com/maps/api/js?key=".concat(apiKey, "&libraries=places");
    script.src = src;
    var position = document.querySelector('head');
    position.appendChild(script);
    script.addEventListener('load', onLoad);
    script.addEventListener('error', onError); // Remove script on unload

    return () => {
      var scriptToRemove = document.getElementById(scriptId);
      scriptToRemove === null || scriptToRemove === void 0 ? void 0 : scriptToRemove.remove();
    };
  }, []);
  return /*#__PURE__*/React__namespace.createElement(GoogleMapsContext.GoogleMapsContext.Provider, {
    value: _rollupPluginBabelHelpers.objectSpread2({}, state)
  }, children);
}
GoogleMapsProvider.propTypes = {
  /** Id for the Google Maps script tag. */
  scriptId: index.string,

  /** Wrapped content of the provider. */
  children: index.node,

  /** Your Google Maps api key. Keep it secret. Keep it safe. */
  apiKey: index.string.isRequired
};

exports.DEFAULT_GOOGLE_MAPS_SCRIPT_ID = DEFAULT_GOOGLE_MAPS_SCRIPT_ID;
exports.GoogleMapsProvider = GoogleMapsProvider;
